
import styled from "styled-components";
import { fontFamilies } from "components/shared/tokens/typography";

const Container = styled.div`
  background: rgba(255, 255, 255, 1);
  width: 320px;
  height: 48px;
  padding: 12px 16px;
  gap: 12px;
  border-radius: 100px;
  border: 1px solid rgba(230, 233, 239, 1);
  display: flex;
  align-items: center;
  box-sizing: border-box;
`;

const Icon = styled.img`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
`;

const Input = styled.input`
  color: rgba(175, 180, 192, 1);
  font-family: ${fontFamilies.regular};
  font-size: 16px;
  line-height: 24px;
  border: none;
  outline: none;
  background: transparent;
  width: 100%;

  &::placeholder {
    color: rgba(175, 180, 192, 1);
  }
`;

/**
 * SearchBarRed – a reusable pill-shaped search input.
 *
 * Props:
 *   placeholder  {string}    – input placeholder text  (default: "Search items")
 *   value        {string}    – controlled input value
 *   onChange     {function}  – called with the raw input event (event.target.value)
 *   ...rest                  – any other valid <input> attributes (e.g. autoFocus, disabled)
 */
export default function SearchBarRed({
  placeholder = "Search items",
  value,
  onChange,
  ...rest
}) {
  return (
    <Container>
      <Icon src="/logos/search-icon.svg" alt="" aria-hidden="true" />
      <Input
        type="search"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        {...rest}
      />
    </Container>
  );
}
